function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FAKE_LOGGER_METHOD_MAP = {
  info: 'log',
  warning: 'warn',
  error: 'error'
},
    fakeLogger = {
  notify: function notify(message, options) {
    var methodName = FAKE_LOGGER_METHOD_MAP[options.severity]; // eslint-disable-next-line no-console

    console[methodName](message, options.metaData);
  }
},
    getWindowObject = require('../feature-detection').getWindowObject,
    initialFeatureName;

function _getLogger() {
  var logger = getWindowObject('bugsnagClient') || fakeLogger; // NOTE: The busgnagClient object would have been set up with a context property.
  // It doesn't exist on the fakeLogger

  initialFeatureName = logger.context;
  return logger;
}

function _notify(severity, message, metaData, callbacks) {
  _getLogger().notify(message, _objectSpread({
    metaData: metaData,
    severity: severity
  }, callbacks));
}

module.exports = {
  getOriginalPageName: function getOriginalPageName() {
    _getLogger();

    return initialFeatureName;
  },
  setPageName: function setPageName(featureName) {
    _getLogger().context = featureName;
  },
  info: _notify.bind(null, 'info'),
  warn: _notify.bind(null, 'warning'),
  error: _notify.bind(null, 'error')
};